import { Select } from './select';
import { SelectAsync } from './select-asnyc';

export const Dropdowns = {
  Select: Select,
  SelectAsync: SelectAsync,
};
